// Styles for CardHorizontalFeature go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledCardHorizontalFeature = styled.div`
  .card-horizontal-container {
    border-radius: 0;
  }

  .cta-btn {
    padding: ${toRem(3)} ${toRem(16)};
  }

  .t-overline-alt-normal {
    margin-bottom: ${toRem(12)};
  }

  svg {
    height: ${toRem(48)};
    width: ${toRem(48)};
  }
  .card-horizontal-container {
    box-shadow: none;
  }
`;
